import { cn } from '@client/lib';

interface AdvisorOnboardingHeaderProps {
  title?: string;
  currentStep: number;
  totalSteps: number;
}

export function AdvisorOnboardingHeader({
  title,
  currentStep,
  totalSteps,
}: AdvisorOnboardingHeaderProps) {
  const steps = Array.from({ length: totalSteps });

  return (
    <div className="sticky top-0 z-10 border-b border-gray-200 bg-white">
      <div className="mx-auto max-w-5xl space-y-4 p-6">
        <div className="flex items-center gap-2 text-sm">
          <span className="font-semibold text-gray-950">{title}</span>
          <span className="text-gray-600">•</span>
          <span className="text-gray-600">
            Step {currentStep + 1} of {totalSteps}
          </span>
        </div>
        <div className="flex items-center gap-4">
          {steps.map((_, idx) => (
            <div
              key={idx}
              className={cn('h-1 w-full rounded-full bg-gray-200', {
                'bg-primary/50': idx === currentStep,
                'bg-primary': idx < currentStep,
              })}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
